import { stringToNumber } from 'annotation-tools/utils';
import { match } from 'react-router-dom';
import { RouteParam, routes } from './routes';

export const redirectRules: {
  from: string;
  to: (match: match<RouteParam>) => string;
}[] = [
  {
    from: routes.koumutenPlaceholder,
    to: (match: match<RouteParam>) =>
      routes.companyList(stringToNumber(match.params.koumutenId ?? '0') ?? 0)
  },
  {
    from: routes.companyPlaceholder,
    to: (match: match<RouteParam>) =>
      routes.projectList(
        stringToNumber(match.params.koumutenId ?? '0') ?? 0,
        stringToNumber(match.params.companyId ?? '0') ?? 0
      )
  }
];
